import { render, staticRenderFns } from "./TaxpayerTypes.vue?vue&type=template&id=111f1a9c&scoped=true&"
import script from "./TaxpayerTypes.vue?vue&type=script&lang=js&"
export * from "./TaxpayerTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111f1a9c",
  null
  
)

export default component.exports